import { parkingProductsTypes } from "../action-types/parkingProducts.types";
import { Success, success } from "../helpers/action.helper";
import { ParkingProductsActionType } from "./parkingProducts.actions";

type GetLocatedParkingProductsSuccess = {
    type: Success<typeof parkingProductsTypes.GET_LOCATED_PARKING_PRODUCTS>;
} & Required<Pick<ParkingProductsActionType, 'locatedParkingProductsPayload'>>;

export function isLocatedParkingProductsSuccess(action: any): action is GetLocatedParkingProductsSuccess {
    return action?.type === success(parkingProductsTypes.GET_LOCATED_PARKING_PRODUCTS) && Array.isArray(action.locatedParkingProductsPayload);
}
